import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import CustomTable from '../../components/table/CustomTable';
import { updateSearchData, updateSearchMemory, updateExtraSearchTitles } from '../../redux/actions/analyticsAction';


export default function LoansPage() {
    const profile = useSelector((store) => store.user.profile);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const searchMemory = useSelector((store) => store.analytics.searchMemory);
    const searchData = useSelector((store) => store.analytics.searchData);
    const extraSearchTitles = useSelector((store) => store.analytics.extraSearchTitles);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        dispatch(updateSearchMemory(null));
        dispatch(updateSearchData([]));
        dispatch(updateExtraSearchTitles([]));
    }, []);

    useEffect(() => {
        if(profile.user_type !== "superadmin"){
            navigate("/");
        }
    }, [profile]);

    const fetchData = async (page, limit) => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${localStorage.getItem("userToken")}`);
        
        const raw = JSON.stringify({
          "page": page,
          "limit": limit
        });
    
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };

        try {
            const response = await fetch(`${window.backendUrl}/api/v1/data/loans`, requestOptions);
            const result = await response.json();
            console.log(result);
            setTotal(result?.data?.total);
            return result?.data;
        } catch (error) {
            console.error(error);
            return {};
        }
    };

    const submitSearch = async (searchColumn, searchQuery) => {
        if(searchMemory !== null){
          if(searchMemory[searchColumn]){
            return searchData;
          } else {
            const newSearchData = searchData.filter(item => item[searchColumn] === searchQuery);
            let searchMemoryTemp = searchMemory;
            searchMemoryTemp[searchColumn] = {
              "title": searchData[0][searchColumn],
              "total": newSearchData.length
            }
            let searchTitlesTemp = extraSearchTitles;
            searchTitlesTemp.push(`${newSearchData[0][searchColumn]} (${newSearchData?.length?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})`);
            dispatch(updateSearchMemory(searchMemoryTemp));
            dispatch(updateExtraSearchTitles(searchTitlesTemp))
            dispatch(updateSearchData(newSearchData));
            return newSearchData;
          }
        } else {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          myHeaders.append("Authorization", `Bearer ${localStorage.getItem("userToken")}`);
          
          const raw = JSON.stringify({
            searchColumn,
            searchQuery
          });
    
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
          };
    
          try {
              const response = await fetch(`${window.backendUrl}/api/v1/data/search-loans`, requestOptions);
              const result = await response.json();
              console.log(result);
              if(result.data.length > 0){
                let searchMemory = {};
                searchMemory[searchColumn] = {
                  "title": result?.data[0][searchColumn],
                  "total": result.data.length
                }
                dispatch(updateSearchMemory(searchMemory));
                console.log(result.data[0]);
                dispatch(updateExtraSearchTitles([`${result.data[0][searchColumn]} (${result?.data?.length?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})`]))
                dispatch(updateSearchData(result.data));
              }
              return result.data;
          } catch (error) {
              console.error(error);
              return {};
          }
        }
    }

    return (
        <PageWrapper>
            <div style={{display: "flex", flexDirection: "row", gap: 20,}}>
                <h2 className="page-title">Loans ({total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</h2>
            </div>
            
            <CustomTable 
                columns = {[
                    { field: "date", header: "Date", width: 500},
                    { field: "matric_number", header: "Matric_Number", width: 500},
                    { field: "name", header: "Name", width: 500},
                    { field: "email", header: "Email", width: 400 },
                    { field: "requested_amount", header: "Requested_Amount", width: 400 },
                    { field: "number_of_payment", header: "Number_of_Payment", width: 400 },
                    { field: "salary_amount", header: "Salary_Amount", width: 400},
                    { field: "salary_date", header: "Salary_Date", width: 400 },
                    { field: "employment_type", header: "Employment_Type", width: 400 },
                    { field: "bvn", header: "BVN", width: 400 },
                    { field: "document1", header: "Documents", width: 400 },
                    { field: "status", header: "Status", width: 400 },
                ]}
                fetchData={fetchData}
                submitSearch={submitSearch} 
            />
        </PageWrapper>
    );
}

const PageWrapper = styled('div')(() => ({
    backgroundColor: '#fff',
    width: '100%',
    padding: '30px',
    boxSizing: 'border-box',
    minHeight: '75vh',
}));
